module.exports = __webpack_public_path__ + "static/img/专题活动页设计-3D渲染类活动页.be3aa91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/专题活动页设计-3D渲染类活动页.png
// module id = zuAa
// module chunks = 1